import { connect } from 'react-redux'
import { selectFirstNonZeroPinnedSearch } from 'selectors/left_nav'
import EmptyStateDesktop from './view'

const select = state => ({
  nextSearch: selectFirstNonZeroPinnedSearch(state),
})

export default connect(select)(EmptyStateDesktop)
